"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamePage = GamePage;
const React = __importStar(require("react"));
const react_media_1 = __importDefault(require("react-media"));
const guest_1 = require("~/auth/guest");
const game_1 = require("~/components/game");
function GamePage() {
    return (React.createElement(guest_1.GuestAuthProvider, null,
        React.createElement(react_media_1.default, { query: "(orientation: landscape) and (min-width: 1200px)" },
            React.createElement(game_1.DesktopGame, null)),
        React.createElement(react_media_1.default, { query: "(orientation: landscape) and (max-width: 1199px) and (min-width: 600px)" },
            React.createElement(game_1.MobileGame, null)),
        React.createElement(react_media_1.default, { query: "(orientation: portrait), (max-width: 599px)" },
            React.createElement(game_1.MobileGame, null))));
}
